import { memo } from "react";
import { Box, Chip, Typography } from "@mui/material";
import PropTypes from "prop-types";

const SoStatusChip = ({
  label,
  bgColor,
  textColor,
  showDot,
  fontWeight,
  fontSize,
  height,
  border,
}) => (
  <Chip
    label={
      showDot ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "100%",
              bgcolor: textColor,
              flexShrink: 0,
            }}
          />
          <Typography sx={{ fontSize, fontWeight, color: textColor }}>
            {label}
          </Typography>
        </Box>
      ) : (
        <Typography sx={{ fontSize, fontWeight, color: textColor }}>
          {label}
        </Typography>
      )
    }
    size="small"
    sx={{
      height,
      borderRadius: "12px",
      bgcolor: bgColor,
      ...(border && { border }),
      "& .MuiChip-label": { px: "10px" },
    }}
  />
);

SoStatusChip.propTypes = {
  label: PropTypes.node.isRequired,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  showDot: PropTypes.bool,
  fontWeight: PropTypes.number,
  fontSize: PropTypes.number,
  height: PropTypes.number,
  border: PropTypes.string,
};

SoStatusChip.defaultProps = {
  bgColor: "grey.200",
  textColor: "text.secondary",
  showDot: false,
  fontWeight: 700,
  fontSize: 12,
  height: 24,
  border: null,
};

export default memo(SoStatusChip);
